import PropTypes from 'prop-types';

import theme from '../../utils/theme';

import { ReactComponent as MusicIcon } from '../../icons/music-double-note.svg';

/**
 * The pills beside a part's chip: who it is assigned to, and the instruments on it, on a line of
 * their own. Shared by View and the chart player's run so the two read the same. Styled by the
 * part-assignment-pills mixin, which whatever lays out the chip row includes.
 *
 * @param {string} name - The part's name, for its colour
 * @param {string[]} people - Names as shown
 */
const PartAssignments = ({ name, people = [], instruments = [] }) => (
  <>
    {people.length > 0 && <span className={theme.renderPartColor(name, 'assigned')}>{people.join(', ')}</span>}
    {instruments.length > 0 && (
      <span className="instruments-row">
        <span className={theme.renderPartColor(name, 'assigned instruments')}>
          <MusicIcon className="instruments-icon" aria-hidden="true" />
          {instruments.join(' + ')}
        </span>
      </span>
    )}
  </>
);

PartAssignments.propTypes = {
  name: PropTypes.string.isRequired,
  people: PropTypes.arrayOf(PropTypes.string),
  instruments: PropTypes.arrayOf(PropTypes.string),
};

export default PartAssignments;
